// react
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useGoBack } from 'hooks/useGoBack';
import { ROUTES } from 'router';

// tracking
import { TrackingEvent, useTracking, useCareCircle } from 'hooks';

// components
import BookCallPage from '@karehero/llama/components/pages/Calendly/Calendly';

// store
import { useSelector } from 'store';
import { getAccount } from 'store/slices/iamSlice';

const DEFAULT_CALENDLY_URL =
  'https://calendly.com/care-concierge-kh/care-concierge-initial-call';

const CARE_ASSESSMENT_CALENDLY_URL =
  'https://calendly.com/care-concierge-kh/care-assessment-call-with-care-expert';

const FUND_CONSULTAITON_CALENDLY_URL =
  'https://calendly.com/care-concierge-kh/funding-consultation-with-care-expert';

const ATTENDANCE_ALLOWANCE_CALENDLY_URL =
  'https://calendly.com/care-concierge-kh/attendance-allowance-help';

const KAREHERO_CALL_CALENDLY_URL =
  'https://calendly.com/care-concierge-kh/call-with-karehero';

/**
 * BookCall shows the BookCallPage component.
 */
export const BookCall = () => {
  // hooks
  const { track } = useTracking();
  const navigate = useNavigate();
  const goBack = useGoBack();
  const location = useLocation();
  const account = useSelector(getAccount);
  const { careCircle } = useCareCircle();
  const [searchParams] = useSearchParams();

  const paramCategory = searchParams.get('category');

  const calendlyLink = useMemo(() => {
    switch (paramCategory) {
      case 'find-care':
        return CARE_ASSESSMENT_CALENDLY_URL;
      case 'cover-costs':
        return FUND_CONSULTAITON_CALENDLY_URL;
      case 'attendance-allowance':
        return ATTENDANCE_ALLOWANCE_CALENDLY_URL;
      case 'karehero-call':
        return KAREHERO_CALL_CALENDLY_URL;
      default:
        return DEFAULT_CALENDLY_URL;
    }
  }, [paramCategory]);

  // effects
  useEffect(() => {
    track(TrackingEvent.BookCallViewed, {});
  }, [track]);

  return (
    <BookCallPage
      calendlyCallDetails={{
        ...location.state,
        name: account?.firstName || '',
        kindeEmail: account?.kindeEmail || '',
        accountId: account?.id,
        careCircleId: careCircle?.id,
      }}
      isLoading={false}
      baseURL={calendlyLink}
      onBack={goBack}
    />
  );
};

export default BookCall;
